module.exports = __webpack_public_path__ + "static/media/zuzana_hodrova.a32a8559.png";